import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgOracle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-oracle';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 12v8.76h17.52V3.24H3.24zm16 0v7.24H4.76V4.76h14.48zM9.72 8.282a3.98 3.98 0 0 0-2.383 1.135c-.5.5-.844 1.12-1.001 1.803a4.1 4.1 0 0 0 0 1.56c.358 1.557 1.656 2.705 3.321 2.937.413.057 4.273.057 4.686 0 1.673-.233 2.933-1.35 3.324-2.948.082-.334.092-1.171.017-1.509-.331-1.505-1.382-2.577-2.869-2.927-.233-.054-.619-.066-2.515-.075-1.232-.006-2.393.005-2.58.024m5.048 1.586c.341.129.585.285.832.532.4.4.591.833.627 1.42.043.707-.155 1.236-.645 1.719a2.26 2.26 0 0 1-1.061.618c-.286.079-.397.083-2.521.083s-2.235-.004-2.521-.083a2.26 2.26 0 0 1-1.061-.618c-1.116-1.101-.77-2.89.69-3.567.436-.202.534-.208 3.072-.199 2.311.008 2.365.01 2.588.095"
    })
  }));
});
export default SvgOracle;